import { InputText } from "primereact/inputtext";

import { Icon } from "../../../icon";
import styles from "../../search-menu.module.scss";
import type { SearchMenuSearchViewProps } from "./types-search";

/** Campo de busca do cabeçalho (InputText do Prime + lupa `search` 14); sem placeholder, como no Figma. */
export function SearchMenuSearchView({
  testId,
  className,
  ariaLabel,
  value,
  onChange,
  onKeyDown,
  rest,
}: SearchMenuSearchViewProps) {
  return (
    <div className={styles.search}>
      <div className={styles.field}>
        <InputText
          aria-label={ariaLabel}
          className={[styles.input, className].filter(Boolean).join(" ")}
          data-testid={testId}
          {...rest}
          value={value}
          onChange={onChange}
          onKeyDown={onKeyDown}
        />
        <Icon name="search" className={styles.lupa} />
      </div>
    </div>
  );
}
